var handleLinkClick = function handleLinkClick(e, onClick, openLinkInNewTab) {
  if (onClick && !openLinkInNewTab && !(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || e.button)) {
    onClick(e);
    e.preventDefault();
  }
};

export default handleLinkClick;